module.exports = __webpack_public_path__ + "85c26babcf90451fa36c776fbca9fe9d.pdf";